// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop__3hQeV","footer":"footer__8T7Va"};